import qs from 'qs';
import router from '@/router/index';
import { CDN_URL } from '@/config/index';
import dayjs from 'dayjs';
import CryptoJS from "crypto-js";

// 本地链接跳转
/**
 *
 * @param {完整路径} url
 */
export function localLinkJump(url) {
  const routePath = url.split('#')[1];
  const isQuery = routePath.includes('?');
  if (isQuery) {
    const path = routePath.split('?')[0];
    const queryObj = qs.parse(routePath.split('?')[1], { ignoreQueryPrefix: true });
    router.push({ path, query: queryObj });
  } else {
    router.push({ path: routePath });
  }
}

// 表情图标name生成对应dom元素
/**
 *
 *
 * @export
 * @param {string} emojiName
 * @returns {string}
 */
export function createEmojiIcon(emojiName) {
  if (!emojiName) return;
  const path = `${CDN_URL}/emoji/`;
  return `<img src=${path}${emojiName} class="hm-emoji" alt="表情">`;
}

// 给正文中的img 的data-src属性赋值，满足v-lazy懒加载格式
export const letslazyload = (contentp) => {
  let str = contentp;
  try {
    let regexp1 = new RegExp(/(\<img )([^>]*)(src=")([^"]*")([^>]*)(\>)/, 'g');
    contentp = contentp.replace(regexp1, function (match, p1, p2, p3, p4, p5, p6) {
      return (
        p1 +
        p2 +
        'data-loading="' +
        require('@/assets/timg.gif') +
        '"' +
        'data-src="' +
        p4 +
        p5 +
        p6
      );
    });
    return contentp;
  } catch (e) {
    return str;
  }
};
// sdk接口签名生成
export const sort_ASCII = (obj) => {
  let arr = new Array();
  let num = 0;
  const secret = 'TKGKItgT';
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  sortArr = sortArr.map((item) => {
    return `${item}=${encodeURIComponent(obj[item])}`;
  });
  let sortString = `${sortArr.join('&')}${secret}`;
  return {
    ...obj,
    sign: CryptoJS.MD5(sortString).toString(),
  };
};
//显示发布时间的函数
export const pastTime = (_createTime) => {
  //const createTime = _createTime.substr(0, _createTime.lastIndexOf(" ")) //不能包含毫秒，如果有毫秒，进行截取
  let resultStr = '0分钟前';
  if (_createTime) {
    const nowTime = Date.parse(new Date());
    _createTime = _createTime.replace(/-/g, '/');
    const cTime = Date.parse(new Date(_createTime));
    let result = parseInt((nowTime - cTime) / 1000 / 60); //分钟数
    if (result < 0) {
      console.log('接口日期错误，请检查');
    } else if (result == 0) {
      resultStr = '刚刚发布';
    } else if (result > 0 && result < 60) {
      resultStr = result + '分钟前';
    } else if (result >= 60 && result < 1440) {
      result = parseInt(result / 60); //小时
      resultStr = result + '小时前';
    } else if (result >= 1440 && result < 10080) {
      result = parseInt(result / (60 * 24)); //天
      resultStr = result + '天前';
    } else if (result >= 10080 && result < 43200) {
      result = parseInt(result / (60 * 24 * 7)); //周
      resultStr = result + '周前';
    } else if (result >= 43200 && result < 525600) {
      result = parseInt(result / (60 * 24 * 30)); //月
      resultStr = result + '个月前';
    } else if (result >= 525600) {
      result = parseInt(result / (60 * 24 * 365)); //年
      resultStr = result + '年前';
    }
  }
  return resultStr;
};

// 代金券失效剩余时间
export const remainTime = (failureTime) => {
  let resultStr = '剩余0分钟失效';
  const nowTime = dayjs();
  const remainTime = parseInt((failureTime - nowTime) / 1000 / 60); // 剩余分钟数
  if (remainTime < 0) {
    console.log('接口日期错误，请检查');
  } else if (remainTime == 0) {
    resultStr = '剩余0分钟失效';
  } else if (remainTime > 0 && remainTime < 60) {
    resultStr = `剩余${remainTime}分钟失效`; // 分钟
  } else if (remainTime >= 60 && remainTime < 1440) {
    resultStr = `剩余${parseInt(remainTime / 60)}小时失效`; // 小时
  } else if (remainTime >= 1440) {
    resultStr = `剩余${parseInt(remainTime / (60 * 24))}天失效`; // 天
  }
  return resultStr;
};

// 将0-1之间的阿拉伯小数转成中文数字
export const NumberToChinese = (num) => {
  if (num === 0) {
    console.log('NumberToChinese函数参数错误');
    return;
  }
  const numChar = {
    0: '零',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
  };
  let numChinese = '';
  numChinese = numChar[Math.floor(parseFloat(num) * 10)];
  if (!Number.isInteger(parseFloat(num) * 10)) {
    numChinese =
      numChinese +
      numChar[Math.floor(parseFloat(num) * 100 - Math.floor(parseFloat(num) * 10) * 10)];
  }
  return numChinese;
};

// 高亮文本
export function highlight(node, reg) {
  if (node.nodeType == 3) {
    //只处理文本节点
    const match = node.data.match(new RegExp(reg));
    if (match) {
      const highlightEl = document.createElement('span');
      highlightEl.dataset.highlight = 'y';
      highlightEl.className = 'highlight';
      const wordNode = node.splitText(match.index);
      wordNode.splitText(match[0].length); // 切割成前 关键词 后三个Text 节点
      const wordNew = document.createTextNode(wordNode.data);
      highlightEl.appendChild(wordNew); //highlight 节点构建成功
      wordNode.parentNode.replaceChild(highlightEl, wordNode); // 替换该文本节点
    }
  } else if (node.nodeType == 1 && node.dataset.highlight != 'y') {
    for (var i = 0; i < node.childNodes.length; i++) {
      highlight(node.childNodes[i], reg);
    }
  }
}

export const tg_sort_ASCII = (obj) => {
  let arr = new Array();
  let num = 0;
  const secret = "PLATFORM_SHOP_SALT"
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  sortArr = sortArr.map(item => {
    if (obj[item]) {
      return `${item}=${obj[item]}`
    } else {
      return ''
    }
  })
  sortArr = sortArr.filter(item => !!item);
  let sortString = encodeURIComponent(`${sortArr.join("&")}${secret}`);
  return CryptoJS.MD5(sortString).toString().toLowerCase()
}

export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
  } else {
      return false;
  }
}

// 生成 uuid
export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
